import { useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { fuseCards } from "@/api/gameApi"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

export default function FuseCardsPage() {
  const [params] = useSearchParams()
  const mainFromUrl = params.get("mainCardId")
  const [mainId, setMainId] = useState(mainFromUrl ?? "")
  const [sacrificeId, setSacrificeId] = useState("")
  const { collectionCards, syncGameState, bumpCards } = useGuardiansPassport()

  const fuse = useMutation({
    mutationFn: () => fuseCards(mainId, sacrificeId),
    onSuccess: async () => {
      await syncGameState()
      bumpCards()
    },
  })

  const result = fuse.data

  return (
    <GameScreenLayout title="Слияние карт" backTo="/play/collection">
      <p className="mb-3 text-xs text-guardians-muted">
        Основная карта сохраняется, жертвенная исчезает (шанс усиления).
      </p>
      <label className="mb-2 block text-xs">
        Основная
        <select
          value={mainId}
          onChange={(e) => setMainId(e.target.value)}
          className="mt-1 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm"
        >
          <option value="">—</option>
          {collectionCards.map((c) => (
            <option key={c.id} value={c.id}>
              {c.element} Lv.{c.level} {c.colorRank}
            </option>
          ))}
        </select>
      </label>
      <label className="mb-4 block text-xs">
        Жертва
        <select
          value={sacrificeId}
          onChange={(e) => setSacrificeId(e.target.value)}
          className="mt-1 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm"
        >
          <option value="">—</option>
          {collectionCards
            .filter((c) => c.id !== mainId)
            .map((c) => (
              <option key={c.id} value={c.id}>
                {c.element} Lv.{c.level}
              </option>
            ))}
        </select>
      </label>
      <button
        type="button"
        disabled={!mainId || !sacrificeId || fuse.isPending}
        onClick={() => fuse.mutate()}
        className="w-full rounded-xl bg-guardians-accent py-3 text-guardians-bg disabled:opacity-40"
      >
        Слить
      </button>

      {result ? (
        <p className="mt-3 text-sm text-green-300">
          {result.fused ? "Успех слияния!" : "Слияние без апгрейда"} · карта Lv.
          {result.card.level}
        </p>
      ) : null}

      {fuse.isError ? (
        <p className="mt-3 text-sm text-red-300">
          {getGameApiErrorMessage(fuse.error, "Слияние не удалось")}
        </p>
      ) : null}
    </GameScreenLayout>
  )
}
